import React, {PureComponent} from "react"

import withBranding, {WithBranding} from "@irati/brand/withBranding"
import UpdateBrand from "@irati-web/admin/src/components/Settings/Brand"
import BrandPreview, {PreviewVariants} from "./BrandPreview"

interface Props extends WithBranding {
  isDefaultBrand: () => Promise<boolean>,
  setIsStepCompletable: (value: boolean) => void
}

interface State {
  settingBrand: boolean,
  showUpload?: boolean,
  forceColor?: string
}

class SetBrand extends PureComponent<Props, State> {
  state: State = {
    settingBrand: false
  }

  componentDidMount = () => this.props.isDefaultBrand().then((showUpload) => this.setState({showUpload}))

  startSetBrand = () => {
    this.setState({settingBrand: true})
  }

  onBrandUpdated = () => {
    this.props.setIsStepCompletable(true)
    this.setState({settingBrand: false, showUpload: false})
  }

  onColorUpdate = (color: string) => this.setState({forceColor: color})

  render() {
    const {settingBrand, showUpload, forceColor} = this.state
    const {branding} = this.props
    const {businessLogoUrl} = branding
    const variant = showUpload ? PreviewVariants.Unset : PreviewVariants.Custom

    if (!settingBrand) {
      return <BrandPreview forceColor={forceColor} variant={variant} handleClick={this.startSetBrand} />
    }
    return (
      <UpdateBrand
        imageLink={businessLogoUrl}
        showUpload={showUpload}
        onColorUpdate={this.onColorUpdate}
        onBrandUpdated={this.onBrandUpdated} />
    )
  }
}

export default withBranding(SetBrand)
